import { Box, styled } from '@mui/material';

export const DisclaimerContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#E8F4FE',
  borderRadius: '14px',
  boxSizing: 'border-box',
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2.5, 3),
  width: '100%',
}));
